import React from 'react'
import { Slide } from "react-awesome-reveal";
import shape1 from '../../images/story/flower-shape5.svg'
import shape2 from '../../images/story/flower-shape6.svg'
import SectionTitle from '../SectionTitle'


const Storys = [
    {
        animation: '1000',
        title: 'Ceremonia simbólica',
        description: `
        Daniela y Mario no tendrán ceremonia religiosa, sino una 
        <strong>ceremonia simbólica</strong> que se realizará en la 
        <strong>Hacienda Zacapa</strong>. El evento comenzará puntualmente a las 
        <strong>5:30 p.m.</strong> (después del cóctel de bienvenida), por lo que te 
        agradecemos llegar con tiempo para que puedas disfrutarla desde el inicio y ser 
        parte de este momento tan especial.
        <br><br>
        Como referencia, el trayecto desde <strong>Periférico Sur</strong> hasta el 
        <strong>Embarcadero Nativitas</strong> puede tomar entre 
        <strong>35 y 60 minutos</strong> en coche, dependiendo de las condiciones viales.
      `
    },
    {
        animation: '1000',
        title: 'Estacionamiento limitado',
        description: `
        El estacionamiento externo de la Hacienda se encuentra en 
        <strong>Hermenegildo Galeana 260, Barrio Xaltocan, Xochimilco, CDMX</strong>, 
        con costo de <strong>$100</strong> y cupo limitado a <strong>30 autos</strong>. 
        Te recomendamos llegar con anticipación o compartir ride para facilitar el acceso.
        <br><br>
        Si prefieres evitar el tráfico o buscar estacionamiento, considera llegar en 
        <strong>Uber</strong> o <strong>DiDi</strong>; también hay otros estacionamientos 
        públicos cercanos en caso de que el principal esté lleno.
      `
    },
    {
        animation: '1000',
        title: 'Traslados en trajinera',
        description: `
        Las trajineras operarán de <strong>16:00 a 17:40 horas</strong>, así que es 
        importante llegar con tiempo para evitar contratiempos. Te sugerimos estar en el 
        punto de encuentro (<strong>Estacionamiento Zacapa</strong>) alrededor de las 
        <strong>16:00 horas</strong> para abordar con calma, ya que cada trajinera tiene 
        cupo limitado y los traslados se realizarán de manera continua.
      `
    },
    {
        animation: '1000',
        title: 'Ruta peatonal',
        description: `
        Si prefieres no usar trajinera, también puedes caminar entre 
        <strong>6 y 10 minutos</strong> desde el <strong>Embarcadero Nuevo Nativitas</strong> 
        hasta la entrada de <strong>Hacienda Zacapa</strong> (verifica que sea 
        <em>Nuevo Nativitas</em> para evitar confusiones con otros embarcaderos cercanos).
        <br><br>
        Aquí te dejamos un video con la ruta peatonal: 
        <a href="https://vimeo.com/804675785" target="_blank" rel="noopener noreferrer">
          Ver video de la ruta
        </a>
      `
    },
    {
        animation: '1000',
        title: 'Prepárate para el clima',
        description: `
        Xochimilco es una zona húmeda por su cercanía a los canales. El espacio de la 
        <strong>Hacienda Zacapa</strong> es un jardín abierto con carpa y algunos calentadores; 
        sin embargo, en diciembre las temperaturas suelen bajar por la tarde-noche, con un 
        intervalo estimado de <strong>8&nbsp;°C a 20&nbsp;°C</strong> y muy baja probabilidad de lluvia.
        <br><br>
        Te recomendamos llevar <strong>abrigo o algo ligero para cubrirte</strong>, y si tu 
        atuendo es sin mangas, una <strong>pashmina o rebozo</strong> será tu mejor aliado para 
        mantenerte cómoda y disfrutar sin pasar frío.
      `
    },
    {
        animation: '1000',
        title: 'Código de vestimenta: formal y cómodo',
        description: `
        La temática de la boda será <strong>mexicana</strong>, con un código de vestimenta 
        <strong>formal pero cómodo</strong>. Puedes agregar un toque mexicano a tu outfit si lo 
        deseas (desde un detalle de color hasta algún accesorio).
        <br><br>
        Te recomendamos llevar <strong>calzado cómodo</strong>, como tacones anchos o incluso 
        un <strong>cambio de tenis</strong>, para poder bailar toda la noche y moverte sin problema 
        al subir y bajar de las trajineras.
        <br><br>
        Solo recuerda que los colores <strong>blanco</strong>, <strong>verde salvia (sage)</strong> 
        y <strong>verde botella</strong> están reservados para el grupo cercano a los novios.
      `
    },
    {
        animation: '1000',
        title: 'Mosquitos (los menos, pero por si acaso)',
        description: `
        En diciembre, el clima fresco de Xochimilco mantiene a raya a la mayoría de los 
        mosquitos, aunque por la cercanía al humedal siempre puede aparecer algún visitante 
        inesperado. Habrá algunos insumos en los baños, pero si lo prefieres, puedes llevar tu 
        propio <strong>repelente</strong>.
      `
    },
    {
        animation: '1000',
        title: 'Mesa de regalos',
        description: `
        En esta página encontrarás todos los detalles de nuestra 
        <strong>mesa de regalos no tradicional</strong>. En lugar de objetos, podrás elegir entre 
        <strong>experiencias y aportaciones personalizadas</strong> que puedes enviar vía 
        <strong>transferencia electrónica</strong>.
        Puedes visitarla <a href="https://alcancia.online/evento/daniela-y-mario" target="_blank" rel="noopener noreferrer">aquí</a>.
        <br><br>
        Si lo prefieres, también podrás hacerlo el día de la boda en efectivo, ¡incluso sumarte 
        a la <strong>vaquita para la hora extra</strong>! Agradecemos mucho tu cariño y apoyo para 
        hacer de este día una celebración inolvidable.
      `
    },
    {
        animation: '1000',
        title: 'Contacto el día del evento',
        description: `
        Si tienes alguna duda o surge algún cambio en tu asistencia o la de tus acompañantes, 
        te pedimos por favor notificarnos a la brevedad, de preferencia antes del 
        <strong>15 de noviembre</strong>. Esto nos ayudará a ajustar la logística.
        <br><br>
        Puedes escribirle a nuestro <strong>asistente virtual</strong> al 
        <a href="tel:+525525343404">+52 55 2534 3404</a>, o ponerte en contacto con nuestra 
        <strong>wedding planner, Ericka Lazarini</strong>, al 
        <a href="tel:+525522719079">+52 55 2271 9079</a>.
      `
    }
];


const StorySection3 = (props) => {
    return (
        <section className="wpo-story-section-s3 pt-5" id="story">
            <div className="container-fluid">
                <SectionTitle subTitle={'Otras recomendaciones'} MainTitle={''} s2Class={'mb-0'} />
                <div className="wpo-story-wrap">
                    <div className="row">
                        {
                            Storys.map((story, st) => {
                                const isEven = (st + 1) % 2 === 0;
                                const flowerShape = isEven ? shape2 : shape1;
                                return (
                                    <div className={`col col-12 ${isEven ? 'story-item-even' : 'story-item-odd'}`} key={st}>
                                        <Slide direction="up" duration={story.animation} triggerOnce="true">
                                            <div className="wpo-story-item">
                                                <div className="flower-shape">
                                                    <img src={flowerShape} alt="" />
                                                </div>
                                                <div className="wpo-story-content">
                                                    <h2>{st + 1}. {story.title}</h2>
                                                    <div dangerouslySetInnerHTML={{ __html: story.description }} />
                                                </div>
                                            </div>
                                        </Slide>
                                    </div>
                                )
                            })
                        }
                    </div>
                </div>
            </div>
        </section>
    )
}

export default StorySection3;
